import { useAuth } from '@/hooks/useAuth';
import { useBanners } from '@/hooks/useBanners';
import Banner from './Banner';

/**
 * BannerList fetches and displays all active banners.
 *
 * Auto-polls every 5 minutes (via the useBanners hook) and can be
 * triggered via WebSocket events. Only fetches when authenticated.
 *
 * Rendered inside AppShell's `banners` slot — sticky between topbar
 * and main content.
 */
export default function BannerList() {
  const { user } = useAuth();
  const { data: banners, isLoading, isError } = useBanners(!!user);

  if (isLoading || isError) return null;
  if (!banners || banners.length === 0) return null;

  return (
    <div className="sticky top-0 z-20 w-full">
      {banners.map((banner) => (
        <Banner key={banner.id} banner={banner} />
      ))}
    </div>
  );
}
